import OurPartners from './OurPartners'

export default OurPartners
